<template>
  <div class="how-class">
    <div class="ha-des">
      <p>可瀚学堂采用的是讯飞语音评测技术，下面从以下几个问题解答一下APP内的语音评测技术。</p>
      <p class="black">问：发音评测维度有哪些？</p>
      <p>答：讯飞语音评测技术可从多方面对语音进行评测，如准确度、流畅度、完整度、意群停顿、连读、重读、句末升调等，每一维度都能得到对应的评测结果。可瀚学堂APP已开通讯飞语音评测全维度权限，并从多种维度中精选了准确、流畅、完整三大维度对用户语音进行评分。</p>
      <p class="black">问：评测对象是什么？</p>
      <p>答：讯飞语音评测技术评测对象可分为单词评分、整句评分、整段评分。若想实现更细粒度的评分，还能针对音节、音素进行评测。可瀚学堂APP拥有讯飞独家授权的最高阶的长文本评测技术，评测文本长度不受限制，并能在极短时间内得出长文本语音的评测结果。</p>
      <div class="ha-img">
        <img src="./img/evaluate_1.png" alt="">
      </div>      
      <p class="black">问：各维度分数名称表示什么含义？</p>
      <p>答：各维度分数名称的含义如下：</p>
        <ul class="list">
            <li>准确度分，对朗读内容的正确程度进行评分；</li>
            <li>流畅度分，对朗读的流利程度进行评分；</li>
            <li>完整度分，针对有固定文本的试题，对朗读的完整性进行评分；</li>
            <li>总分，对语音的总体评价，可以是各维度平均，或根据需要进行加权，也可以作为一个独立维度。</li>
        </ul>
        <p class="black">问：能监测出哪些评测异常情况？</p>
        <p>答：评测时可以识别出各种异常情况，如漏读、增读、回读、替换、乱读、语音过小、噪音等。</p>
         <div class="ha-img">
        <img src="./img/evaluate_2.png" alt="">
      </div>      
    </div>
    
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-class {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p{
        margin: p2r(10) 0;
      }
      a{
        color: $blue;
      }
      .list{
          list-style-type: disc;
          padding-left: 20px;
      }
    }
    .ha-img {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
</style>
<script>
  export default{
    data(){
      return {
        msg: 'hello vue'
      }
    },
    created(){
      document.title='语音评测如何打分? 可瀚学堂-深圳市格熙信息科技有限公司'
      this.$sendAnalytics('语音评测如何打分')
    },
    components: {}
  }
</script>
